<template>
    <div class="selectLogin">
        <div class="tl-title">请选择您的角色</div>
        <div class="login-btn btn-light" @click="selectLogin(0)">代账公司员工</div>
        <div class="login-btn btn-light" @click="selectLogin(1)">企业客户</div>
    </div>
</template>

<script>
import Vue from "vue";
import { Dialog, Toast } from "vant";
import wx from "weixin-js-sdk";
import { setCookie, getCookie, delCookie } from '@/common/lib/utils/cookie.js';
Vue.use(Dialog);

export default {
  name: "selectLogin",
  components: {},
  data() {
    return {
      env: "",
      loginInfo:this.$route.query
    };
  },
  beforeMount() {
    Vue.prototype.$cookieStore = {
      setCookie,
      getCookie,
      delCookie
    }
  },
  mounted() {},
  methods: {
    getRnv() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            this.env = "miniprogram";
          } else {
            this.env = "public";
          }
        });
      } else {
        this.env = "public";
      }
    },
    selectLogin(flag) {

      // flag = 0  代账公司职员，  flag =1 企业客户

      Toast.loading({
        mask: true,
        message: "登录中..."
      });

      let param = {
        identity:flag,
        username: this.loginInfo.telphone,
        vcode: this.loginInfo.code,
        openid: this.loginInfo.openId
      };
      if (this.loginInfo.origin === "public") {
        param.eid = this.loginInfo.eid ? this.loginInfo.eid : window.sessionStorage.getItem("eid");
      }
      this.$http.get("/mini/user/login/phone", { params: param }).then(res => {
        Toast.clear();
        if (res.data.code == 200) {
          let result = res.data.data;
          this.$store.dispatch("setLoginState", true);
          this.$store.dispatch("setUserInfo", result);
          window.sessionStorage.setItem("openId", result.openid);
          window.sessionStorage.setItem("staffId", result.staff && result.staff.staffId);
          window.sessionStorage.setItem('userType',result.userType);
          // if (this.loginInfo.origin === "LittleProgram") {
             window.localStorage.setItem('taxAuthPhone', this.loginInfo.telphone)
          // }
          if (result.userType == 1) {
            this.$cookieStore.setCookie('accCompanyId', result.staff && result.staff.accCompany && result.staff.accCompany.accCompanyId);
            this.$root.$emit('show-homeIcon',"1");
            if (this.loginInfo.origin === "LittleProgram") {
              this.$router.push({
                name: "accountHome"
              });
            } else
              this.$router.replace({
                name: "accountHome"
              });
          } else {
            if (this.loginInfo.origin === "LittleProgram") {
              this.$router.push({
                name: "companyHome"
              });
            } else
              this.$router.replace({
                name: "companyHome"
              });
          }
        } else {
            console.log('手机号不是管家权限')
            // this.loginInfo.origin === "LittleProgram" &&
            if (window.sessionStorage.getItem('taxAuth') && window.sessionStorage.getItem('taxAuth') !== '{}') {
                window.sessionStorage.setItem('taxAuth', JSON.stringify({'phone': this.loginInfo.telphone, 'gjAuth': 'noID'}))
                window.localStorage.setItem('taxAuthPhone', this.loginInfo.telphone)
                this.$router.replace({
                    name: 'taxauth'
                });
                return
            }
            Toast(res.data.msg);
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.selectLogin {
    .tl-title{
        text-align center
        margin-top 1.68rem
        font-size: 0.18rem;
        font-weight bold
    }
    .login-btn {
        margin: 0 auto;
        margin-top: 0.4rem;
        height: 0.42rem;
        line-height: 0.42rem;
        text-align: center;
        width: 2.88rem;
        font-size: 0.18rem;
        border-radius: 0.25rem;
    }

    .btn-light {
        background: linear-gradient(#1bc2fd 0%, #2cb3f9 100%);
        box-shadow: 0px 3px 8px 0px rgba(175, 228, 255, 1);
        color: #ffffff;
    }
}
</style>

